(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeaderCustom extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this;
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      // --- STICKY HEADER LOGIC ---
      this.announcementBar = document.querySelector('#shopify-section-announcement-bar');
      this.updateHeaderTopPosition();
      // --- END ---

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      // --- STICKY HEADER OBSERVER ---
      if (this.announcementBar) {
        this.announcementBarObserver = new ResizeObserver(() => {
          this.updateHeaderTopPosition();
        });
        this.announcementBarObserver.observe(this.announcementBar);
      }
      // --- END ---

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    // --- NEW FUNCTION START ---
    updateHeaderTopPosition() {
      if (!this.announcementBar) {
        this.header.style.top = '0px';
        return;
      }
      const announcementBarHeight = this.announcementBar.offsetHeight;
      this.header.style.top = `${announcementBarHeight}px`;
    }
    // --- END ---

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.announcementBarObserver && this.announcementBar) {
        this.announcementBarObserver.unobserve(this.announcementBar);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header-custom', StickyHeaderCustom);

  // --- HOVER MENU FIX WITH NO OVERLAP ---
  document.addEventListener('DOMContentLoaded', () => {
    const mediaQuery = window.matchMedia('(min-width: 990px)');
    // UPDATED: Select 'details' directly to match your Mega Menu HTML structure [cite: 146]
    const megaMenuDetails = document.querySelectorAll('.header__inline-menu details'); 
    
    megaMenuDetails.forEach(menu => {
      const summary = menu.querySelector('summary');
      const content = menu.querySelector('.mega-menu__content');
      let closeTimer = null;

      const openMenu = () => {
        if (mediaQuery.matches) {
          if (closeTimer) clearTimeout(closeTimer); 
          
          // FORCE CLOSE ALL OTHER MENUS
          megaMenuDetails.forEach(otherMenu => {
            if (otherMenu !== menu && otherMenu.hasAttribute('open')) {
               otherMenu.removeAttribute('open');
            }
          });
          menu.setAttribute('open', true);
        }
      };

      const startCloseTimer = () => {
        if (mediaQuery.matches) {
          closeTimer = setTimeout(() => {
            menu.removeAttribute('open');
          }, 100);
        }
      };

      if (summary) {
        summary.addEventListener('mouseenter', openMenu);
        summary.addEventListener('mouseleave', startCloseTimer);
      }
      
      if (content) {
        content.addEventListener('mouseenter', openMenu);
        content.addEventListener('mouseleave', startCloseTimer);
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
